import type { TranslationTopic } from "../models";
import apiService from "./apiService";

class TopicService {

  public listTopics = async (): Promise<TranslationTopic[]> => {
    return apiService.get<TranslationTopic[]>('/api/topics');
  };

  public createTopic = async (title: string, text: string): Promise<TranslationTopic> => {
    return apiService.post<TranslationTopic>('/api/topics', { title, text });
  };

  public updateTopic = async (id: string, title: string, text: string): Promise<TranslationTopic> => {
    return apiService.put<TranslationTopic>(`/api/topics/${id}`, { title, text });
  };

  public deleteTopic = async (id: string): Promise<void> => {
    return apiService.delete(`/api/topics/${id}`);
  };
}

export default new TopicService();
